import axios from "axios";

export function encodeQueryParams(params: Record<string, any>) {
    return new URLSearchParams(params).toString()
}

export function getAuthToken(): string {
    const OIDC_AUTHORITY = process.env.REACT_APP_OIDC_AUTHORITY || "http://localhost:8080/realms/app"
    const OIDC_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID || "public-app"
    const authData = sessionStorage.getItem(`oidc.user:${OIDC_AUTHORITY}:${OIDC_CLIENT_ID}`);
    return authData ? JSON.parse(authData)?.access_token : ""
}

export function getClientId() {
    return process.env.REACT_APP_API_CLIENT_ID;
}


export function getCommonHeaders() {
    return {
        'Content-Type': 'application/json',
    }
}

export function getAuthorizationHeader() {
    return {
        'Authorization': `Bearer ${getAuthToken()}`
    }
}

export const httpClient = axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export function registerBankManagerUser() {
    const endpoint = '/user/register'
    const URL = process.env.REACT_APP_BANK_MANAGER_ROOT_API_URL + endpoint
    return httpClient.post(URL, {}, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}


export function getAccount() {
    const endpoint = '/user/me/accounts'
    const URL = process.env.REACT_APP_BANK_MANAGER_ROOT_API_URL + endpoint
    return httpClient.get(URL, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data.results.length ? data.results[0] : null)
}